import axios from 'axios';
import { clearCookies, clearStorage, getAuth } from 'functions';
import { httpStatus } from 'model/constants/variableConstant';
import { API_SERVER_WS } from 'constants/index';

export const queryClient = axios.create({
  timeout: 3 * 60 * 1000,
  baseURL: API_SERVER_WS,
});

queryClient.interceptors.request.use(
  (config) => {
    const auth = getAuth();

    if (auth?.token) {
      config.headers.Authorization = auth.token;
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  (error) => Promise.reject(error)
);

queryClient.interceptors.response.use(undefined, (error) => {
  try {
    const { response } = error;
    if (response?.status === httpStatus.unauthorized) {
      clearCookies();
      // window.location.href ='/login';
    } else {
      // window.location.href ='/pages/error-page';
    }
  } catch (e) {
    throw Error(e);
  }
});
